"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobsPage = exports.EmployerCTA = void 0;
var react_1 = __importStar(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var react_redux_1 = require("react-redux");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var colors_config_1 = __importDefault(require("../../../../colors.config"));
var get_jobs_1 = require("../../../api/calls/jobs/get_jobs");
var main_1 = require("../../../reducers/slices/main");
var general_1 = require("../../../helpers/general");
var job_card_1 = require("./job_card");
var job_filter_1 = require("../../../components/job_filter");
var employer_application_form_1 = require("./employer/employer_application_form");
var general_2 = require("./helpers/general");
var EmployerCTA = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    return (react_1.default.createElement(doshx_controls_web_1.BoxControl, { className: "bg-gray-100 w-full", variant: "filled", addPadding: false },
        react_1.default.createElement("div", { className: "flex flex-col gap-1 p-8" },
            react_1.default.createElement("div", { className: "flex flex-col gap-1 text-gray-700" },
                react_1.default.createElement("h3", { className: "text-primary font-semibold text-base" }, "Are you an Employer?"),
                react_1.default.createElement("div", { className: "flex flex-col gap-3 text-sm" },
                    react_1.default.createElement("p", null,
                        "Post your job openings, find the right candidates and manage your job listings by",
                        " ",
                        react_1.default.createElement("span", { className: "text-primary font-medium underline hover:cursor-pointer hover:opacity-80", onClick: function () {
                                return (0, general_2.launchApplication)({
                                    title: "Sign Up as an Employer",
                                    form: react_1.default.createElement(employer_application_form_1.EmployerApplicationForm, null),
                                    dispatch: dispatch,
                                    user: user,
                                });
                            } }, "signing up"),
                        " ",
                        "here. If you are already registered as an employer, please click the link below to sign in."),
                    react_1.default.createElement("p", { className: "text-primary font-medium underline hover:cursor-pointer hover:opacity-80", onClick: function () { return (0, general_1.redirectToSocialMediaPage)("https://skyjobs.biz/employer/login"); } },
                        "Sign In ",
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faExternalLink, size: "xs" })))))));
};
exports.EmployerCTA = EmployerCTA;
var JobsPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_1.useState)([]), jobs = _a[0], setJobs = _a[1];
    var _b = (0, react_1.useState)(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = (0, react_1.useState)(1), currentPage = _c[0], setCurrentPage = _c[1];
    var _d = (0, react_1.useState)(0), totalRecords = _d[0], setTotalRecords = _d[1];
    var _e = (0, react_1.useState)(10), recordsPerPage = _e[0], setRecordsPerPage = _e[1];
    var _f = (0, react_1.useState)({}), filters = _f[0], setFilters = _f[1];
    var keyword = filters.keyword, location = filters.location, category = filters.category, jobtype = filters.jobtype, remote_ok = filters.remote_ok;
    (0, react_1.useEffect)(function () {
        getJobs();
    }, [currentPage, keyword, location, category, jobtype, remote_ok]);
    (0, react_1.useEffect)(function () {
        (0, general_1.scrollToTop)();
    }, [currentPage]);
    var getJobs = function () {
        (0, get_jobs_1.get_jobs)(__assign(__assign(__assign(__assign(__assign({ page: currentPage, limit: recordsPerPage }, (keyword && { keyword: keyword })), (category && { category: category })), (location && { location: location })), (jobtype && { jobtype: jobtype })), (remote_ok && { remote_ok: remote_ok })))
            .then(function (response) {
            var _a, _b;
            setIsLoading(false);
            if (response.error === false) {
                setJobs((_a = response.results.jobs) !== null && _a !== void 0 ? _a : []);
                setTotalRecords((_b = response.results.total_count) !== null && _b !== void 0 ? _b : 0);
            }
        })
            .catch(function (error) {
            setIsLoading(false);
            dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [error === null || error === void 0 ? void 0 : error.message] }));
        });
    };
    return (react_1.default.createElement("div", { className: "" }, isLoading ? (react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
        react_1.default.createElement(doshx_controls_web_1.ShimmerBoxControl, null))) : (react_1.default.createElement("div", { className: "relative" },
        react_1.default.createElement("div", { className: "flex flex-row justify-center" },
            react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
                react_1.default.createElement("div", { className: "flex flex-col items-center" },
                    react_1.default.createElement("div", { className: "w-full flex flex-col gap-y-4 pb-8" },
                        react_1.default.createElement("div", { className: "py-20 flex flex-col items-center gap-8" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Job Seekers", size: "3xlarge", textColor: "text-white", center: true }),
                            react_1.default.createElement("div", { className: "flex flex-col pt-4 pb-4 gap-1 justify-center items-center " },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Page description text goes here. Page description text goes here. Page description text goes here. Page description text goes here. Page description text goes here.", size: "medium", textColor: "text-white", center: true }))),
                        react_1.default.createElement("div", { className: "flex flex-col md:flex-row w-full gap-5" },
                            react_1.default.createElement("div", { className: "w-full md:w-2/4 lg:w-1/4" },
                                react_1.default.createElement(job_filter_1.JobFilter, { onFilterChange: function (filters) { return setFilters(filters); } })),
                            react_1.default.createElement("div", { className: "flex flex-col w-full md:w-2/4 lg:w-3/4 gap-5" },
                                react_1.default.createElement(doshx_controls_web_1.BoxControl, { className: "bg-white shadow-md w-full", variant: "filled", addPadding: false },
                                    react_1.default.createElement("div", { className: "flex flex-col gap-1 p-8" },
                                        jobs.length > 0 ? (jobs.map(function (job, index) { var _a; return react_1.default.createElement(job_card_1.JobCard, { key: (_a = job.id) !== null && _a !== void 0 ? _a : index, job: job }); })) : (react_1.default.createElement("div", { className: "flex justify-center items-center bg-gray-100 rounded-md p-3 text-gray-400 font-semibold" },
                                            react_1.default.createElement("p", null, "No jobs available"))),
                                        jobs && jobs.length > 0 && (react_1.default.createElement("div", { className: "mt-7" },
                                            react_1.default.createElement(doshx_controls_web_1.PaginationControl, { currentPage: currentPage, totalRecords: totalRecords, recordsPerPage: recordsPerPage, onClick: function (page) {
                                                    setCurrentPage(page);
                                                } }))))),
                                react_1.default.createElement(exports.EmployerCTA, null))))))),
        react_1.default.createElement("div", { className: "absolute top-0 w-full -z-10" },
            react_1.default.createElement("div", { className: "h-72 bg-primary" }),
            react_1.default.createElement("div", { className: "-mt-[1px]" },
                react_1.default.createElement("svg", { viewBox: "0 0 20 1.5", xmlns: "http://www.w3.org/2000/svg" },
                    react_1.default.createElement("path", { d: "M 0 0 L 20 0 Q 10 3 0 0", fill: colors_config_1.default.primary }))))))));
};
exports.JobsPage = JobsPage;
